import { render, staticRenderFns } from "./PointsRules.vue?vue&type=template&id=879e9d2e&scoped=true"
import script from "./PointsRules.vue?vue&type=script&lang=js"
export * from "./PointsRules.vue?vue&type=script&lang=js"
import style0 from "./PointsRules.vue?vue&type=style&index=0&id=879e9d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879e9d2e",
  null
  
)

export default component.exports